import { createSelector } from '@reduxjs/toolkit';
import { getDirectSalesSaveDisabled } from 'store/dealManagement/selectors';
import { getHasDirectSalesCampaignInfoChanged } from './getHasDirectSalesCampaignInfoChanged';
import { getIsNewDeal } from './getIsNewDeal';

export const getIsDirectSalesCampaignInfoSaveDisabled = createSelector(
  getDirectSalesSaveDisabled,
  getIsNewDeal,
  getHasDirectSalesCampaignInfoChanged,
  (hasMissingMandatoryFields, isNewDeal, hasCampaignInfoChanged) =>
    hasMissingMandatoryFields || (!isNewDeal && !hasCampaignInfoChanged),
);
